module.exports = __webpack_public_path__ + "img/thumbnail-header-11.6a45ad8.jpeg";